import { makeStyles } from '@material-ui/styles'

export const useStyles = makeStyles({
  container: {
    display: "flex",
    alignContent: "center",
    padding: "0 0.5rem",
    width: "fit-content",
    marginTop: "2rem",
    borderRadius: "0 3px 3px 0",
    backgroundColor: "#16697B"
  },
  title: {
    fontSize: "1.25rem",
    fontWeight: "700",
    color: "#FFF"
  }
})